import axios from './index'

class Users {
    getList = (params) => axios.get('/users', {params})
    create = data => axios.post('/user', data)
    update = data => axios.post('/users/update', data)
    updateStatus = data => axios.post('/users/status', data)
    updatePassword = data => axios.post('/users/update/password', data)
    doctorReports = params => axios.get('/reports/doctors', {params})
    patientsReports = params => axios.get('/reports/patients', {params})
    patientReports = params => axios.get('/reports/patient', {params})
}

export default new Users()
